




































































































import {API} from '@/services/api/api';
import {Vue, Component, Provide, Watch} from 'vue-property-decorator';
import {mapActions, mapGetters} from 'vuex';

@Component({
  methods: {
    ...mapActions(['setCurrentTab', 'showSuccessToast', 'showErrorToast']),
  },
  computed: {...mapGetters(['roleList'])},
})
export default class EditClass extends Vue {
  className = '';
  classStatus = false;
  select = 'admin';
  classNameValidationMsg = '';
  classStatusValidationMsg = '';
  selectValidationMsg = '';

  commonValidationMsg = 'This field is required';
  showSuccessToast: any;
  showErrorToast: any;
  isScreenLoading = true;
  roleList: any;
  btnLoader = false;
  filteredGroupIds = [];
  surveyorGroups = [];
  classId: string = null;
  modifyRoleList: any;

  //Life cycle method call on page mounted
  mounted() {
    this.classId = this.$route.params.id;
    this.getClassInfoById();

    if (this.roleList.list) {
      this.modifyRoleList = this.roleList.list.map((obj) => ({
        ...obj,
        isRoleSelected: false,
      }));
    }
  }

  //Get class informaiton  for edit by id
  async getClassInfoById() {
    try {
      const response = await API.fetchClassInfoById(this.classId);

      if (response.data) {
        const data = response.data;
        this.className = data.className;
        this.classStatus = data.isActive;
        this.surveyorGroups = data.surveyorGroups;
        this.findSelectedRoles();
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network Error'});
    } finally {
      this.isScreenLoading = false;
    }
  }

  findSelectedRoles() {
    const selectedRoleIds = this.surveyorGroups.map((me) => me.groupId);
    this.modifyRoleList.forEach((elm) => {
      if (selectedRoleIds.includes(elm.groupId)) {
        elm.isRoleSelected = true;
        this.showData();
      }
    });
  }

  //Validation calss name
  validateClassName() {
    if (this.className === '' || this.className.length < 1) {
      this.classNameValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.classNameValidationMsg = '';
      return true;
    }
  }

  //Validation
  validateSelect() {
    if (this.filteredGroupIds.length < 1) {
      this.selectValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.selectValidationMsg = '';
      return true;
    }
  }

  showData() {
    this.filteredGroupIds = this.modifyRoleList
      .filter((ele: any) => ele.isRoleSelected === true)
      .map((val: any) => {
        return {groupId: val.groupId};
      });
    this.selectValidationMsg = '';
  }

  //Validate all before call APIs
  validateAll() {
    return (
      this.validateClassName() &&
      // this.validateClassStatus() &&
      this.validateSelect()
    );
  }

  //form submit handler
  async _handleUpdate() {
    if (!this.validateAll()) return;

    try {
      this.btnLoader = true;

      const formInput = {
        className: this.className,
        isActive: this.classStatus,
        surveyorGroups: this.filteredGroupIds,
      };
      const response = await API.updateClassInfoById(this.classId, formInput);
      if (response.data) {
        this.showSuccessToast({msg: response.message});
        this.$router.go(-1);
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network Error'});
    } finally {
      this.btnLoader = false;
    }
  }

  //Go back
  goToList() {
    this.$router.go(-1);
  }
}
